import API from './api';

/**
 * Servicio para la gestión de configuraciones de la aplicación
 * Utiliza el API centralizado para mantener consistencia con el resto de la aplicación
 */
const settingsService = {
  /**
   * Obtener toda la configuración (requiere autenticación de admin)
   */
  getSettings: async () => {
    const response = await API.get('/settings');
    return response.data;
  },

  /**
   * Obtener solo información de contacto (público)
   */
  getContactInfo: async () => {
    const response = await API.get('/settings/contact');
    return response.data;
  },

  /**
   * Actualizar configuración completa (requiere autenticación de admin)
   */
  updateSettings: async (settingsData) => {
    const response = await API.put('/settings', settingsData);
    return response.data;
  },

  /**
   * Actualizar solo información de contacto (requiere autenticación de admin)
   */
  updateContactInfo: async (contactData) => {
    const response = await API.put('/settings/contact/update', contactData);
    return response.data;
  },

  /**
   * Actualizar redes sociales (requiere autenticación de admin)
   */
  updateSocialMedia: async (socialData) => {
    const response = await API.put('/settings/social', socialData);
    return response.data;
  },

  /**
   * Obtener configuración de pagos (requiere autenticación de admin)
   */
  getPaymentSettings: async () => {
    const response = await API.get('/settings/payments');
    return response.data;
  },

  /**
   * Actualizar configuración de pagos (requiere autenticación de admin)
   */
  updatePaymentSettings: async (paymentData) => {
    const response = await API.put('/settings/payments', paymentData);
    return response.data;
  },

  /**
   * Restablecer configuración por defecto (requiere autenticación de admin)
   */
  resetSettings: async () => {
    const response = await API.post('/settings/reset');
    return response.data;
  }
};

export default settingsService;
